import { Menu } from '@mui/material';
import { useCallback } from 'react';

import { DeleteOption } from './DeleteOption';
import { DownloadOption } from './DownloadOption';
import { useFloorplanAdminStore } from '../store';

// TODO -> add mouse out timer

type Props = {
  downloadIsDisabled?: boolean;
  onDeleteOptionClick: () => void;
  onDownloadOptionClick: () => void;
};

export const FloorplanContextMenu = ({
  downloadIsDisabled = false,
  onDeleteOptionClick,
  onDownloadOptionClick,
}: Props) => {
  const position = useFloorplanAdminStore((state) => state.positionState);

  const hide = useCallback(() => {
    useFloorplanAdminStore.getState().setContextMenuPosition(null);
  }, []);

  if (!position) return null;

  return (
    <Menu
      open
      onClick={hide}
      onClose={hide}
      anchorReference="anchorPosition"
      anchorPosition={{ top: position.y, left: position.x }}
      disableAutoFocusItem
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      PaperProps={{
        sx: {
          width: '260px',
          minHeight: '64px',
          boxShadow:
            '0px 5px 5px -3px rgba(0,0,0,0.16), 0px 2px 12px 1px rgba(0,0,0,0.12)',
          alignItems: 'center',
          display: 'flex',
        },
      }}
      MenuListProps={{
        'aria-labelledby': 'context-menu',
        onMouseLeave: hide,
        sx: {
          width: '100%',
        },
      }}
      onBackdropClick={hide}
      BackdropProps={{
        style: {
          background: 'transparent',
        },
        onContextMenu: (e) => {
          e.preventDefault();
          hide();
        },
      }}
    >
      <DownloadOption
        disabled={downloadIsDisabled}
        onClick={onDownloadOptionClick}
      />
      <DeleteOption onClick={onDeleteOptionClick} />
    </Menu>
  );
};
